import React from 'react';
import { connectInfiniteHits } from 'react-instantsearch/connectors';
import Products from './Products';

export default connectInfiniteHits(props => <Products {...props} products={props.hits} />);
